import React, { useEffect, useState } from 'react';
import './user-search.scss';
import { Icon, useModal } from '@ampol/design-system';
import SearchInput from '../search-input/search-input';
import { useDispatch, useSelector } from 'react-redux';
import { impersonateUser, searchAllImpersonateUsers, searchAllImpersonateUsersReset } from '../../actions/userActions';
import OutsideClickHandler from 'react-outside-click-handler/esm/OutsideClickHandler';

const UserSearch = ({ onSearchActive }) => {
  const dispatch = useDispatch();

  const [isSearchMode, setIsSearchMode] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [okDisabled, setOkDisabled] = useState(false);

  const users = useSelector((state) => state.userStore.filteredUsers);
  const isLoaded = useSelector((state) => state.userStore.filteredLoaded);
  const isLoading = useSelector((state) => state.userStore.filteredLoading);
  const isImpersonateLoaded = useSelector((state) => state.userStore.impersonateLoaded);
  const isImpersonateError = useSelector((state) => state.userStore.impersonateError);

  useEffect(() => {
    if (isImpersonateLoaded) {
      closeImpersonateModal();
    }
  }, [isImpersonateLoaded]);

  useEffect(() => {
    if (isImpersonateError) {
      closeImpersonateModal();

      confirmErrorModal.open();
    }
  }, [isImpersonateError]);

  const closeImpersonateModal = () => {
    setOkDisabled(false);
    resetSearch(false);
    setSelectedUser({});
    confirmImpersonateModal.close();
  };

  const handleOKClick = () => {
    if (!okDisabled) {
      setOkDisabled(true);
      dispatch(impersonateUser(selectedUser.userId));
    }
  };

  const toggleSearch = () => {
    resetSearch(!isSearchMode);
  };
  
  const resetSearch = (showSearchInput) => {
    onSearchActive && onSearchActive(showSearchInput);
    setIsSearchMode(showSearchInput);

    if (isLoaded) {
      // reset to defaults
      setOkDisabled(false);

      dispatch(searchAllImpersonateUsersReset());
    }
  };

  const confirmErrorModal = useModal({
    id: 'impersonate-error',
    content: 'There was issue with the request.  Please select a user and try again.',
    variant: 'single',
    color: 'blue',
    actions: [
      {
        label: 'Close',
        onClick: () => confirmErrorModal.close(),
      }
    ]
  });

  const confirmImpersonateModal = useModal({
    id: 'confirm-user-impersonate',
    content: <div>
      Please login to the Card portal (customer) with your ID to impersonate user - {selectedUser.givenName} {selectedUser.familyName} - {selectedUser.emailId}.
      You must logout of an existing impersonation session (if applicable). Click OK to proceed.
    </div>,
    variant: 'double',
    color: 'blue',
    onClose: () => resetSearch(false),
    actions: [
      {
        label: 'Ok',
        onClick: handleOKClick,
        inactive: okDisabled,

      },
      {
        label: 'Cancel',
        onClick: closeImpersonateModal,
      }
    ]
  });

  const handleSearch = (value) => {
    if (value.length > 2) {
      dispatch(searchAllImpersonateUsers(value));
    } else {
      dispatch(searchAllImpersonateUsersReset());
    }
  };

  useEffect(() => {
    if (Object.keys(selectedUser).length) {
      confirmImpersonateModal.open();
    }
  }, [selectedUser]);

  const handleUserSelect = (user) => {
    setSelectedUser(user);
  };

  return <>
    <div className={`user-search ${isSearchMode ? 'user-search--active' : ''}`}>
      <span className="user-search__label">View as:</span>
      {!isSearchMode &&
        <button type={'button'} className="user-search__button" aria-label={'Search Users'} onClick={toggleSearch}>
          <Icon url={'/icons/search.svg'}/>
        </button>
      }
      {isSearchMode && <div className="user-search__container">
        <OutsideClickHandler onOutsideClick={() => {resetSearch(false);}}>
          <SearchInput placeHolder="Search for user" onSearch={handleSearch} className="user-search__input" hasFocus={true} />
          {users.length === 0 && isLoading && <>
            <div className="user-search__options">
              <ul className="user-search__option-list user-search__option-list--loading">
                {Array.from(Array(3)).map((_, index) => <li key={index} className="user-search__option-item" />)}
              </ul>
            </div>
          </>}
          {users.length === 0 && isLoaded &&
            <div className="user-search__options user-search__options--empty">
              <p>No users found</p>
            </div>}

          {users.length > 0 && <div className="user-search__options">
            <ul className="user-search__option-list">
              {users.map((user) => <li key={user.userId} className="user-search__option-item">
                <button
                  className="user-search__option-button"
                  onClick={() => handleUserSelect(user)}>
                  {user.givenName} {user.familyName} - {user.emailId}
                </button>
              </li>)}
            </ul>
          </div>}
        </OutsideClickHandler>
      </div>}
    </div>
  </>;
};

export default UserSearch;
